import { i18n } from "@libs/i18n";
import { StaffRoleType, StaffStatusType } from "@/domain/staff";

export const formatStaffRole = (role: StaffRoleType | undefined) => {
  switch (role) {
    case "OWNER":
      return i18n.t("common:staffRole.owner");
    case "CENTRAL_MANAGER":
      return i18n.t("common:staffRole.centralManager");
    case "CSR":
      return i18n.t("common:staffRole.csr");
    case "CAMPUS_MANAGER":
      return i18n.t("common:staffRole.campusManager");
    case "INSTRUCTOR":
      return i18n.t("common:staffRole.instructor");
    default:
      return "";
  }
};

export const formatStaffStatus = (status: StaffStatusType | undefined) => {
  switch (status) {
    case "ACTIVE":
      return i18n.t("common:active");
    case "DEACTIVATED":
      return i18n.t("common:deactivated");
    default:
      return "";
  }
};
